import { render, staticRenderFns } from "./ToDoMenu.vue?vue&type=template&id=ac8773c4&"
import script from "./ToDoMenu.vue?vue&type=script&lang=js&"
export * from "./ToDoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ToDoMenu.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports